import React from 'react'
import useSettingsManager from '../hooks/use-settings-manager'

function OtherOptionWysisygContent (props) {

  const settings = useSettingsManager()
  const content = settings.getOtherSettings(props.name, '')

  return (
    <div className={'other-option-wysiwyg-content'} data-name={props.name}
         dangerouslySetInnerHTML={{ __html: content }}></div>
  )
}

export default OtherOptionWysisygContent